// @flow
import config from '../config.json';

const profile = process.env.REACT_APP_ENV || 'local';

const serverUrl = config.server[profile];
const authUrl = `${serverUrl}/login`;

type Payload = {
  username: string,
  password: string,
};

const authenticate = async (payload: Payload) => {
  const headers = new Headers();
  headers.set('Content-Type', 'application/json');

  const response = await fetch(authUrl, {
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(payload),
    headers,
  });

  if (response.ok) {
    return response.json();
  }

  throw Error(await response.json());
};

export { authenticate, serverUrl };



// WEBPACK FOOTER //
// ./src/service/index.js